import axios from "axios";
// import config from "../static/json/config.json";

const baseRequest = axios.create( {
    baseURL: window.api_path
} );

const errorHandling = ( err ) => {

    let errObj;

    if ( err.response ) {

        console.log( "Request made and server responded." );
        console.log( err.response.data );
        console.log( err.response.status );
        errObj = err.response.data;

    } else if ( err.request ) {

        console.log( "The request was made but no response was received." );
        console.log( err.request );
        errObj = err.request;

    } else {

        console.log( "Something happened in setting up the request that triggered an Error." );
        console.log( 'Error', err.message );
        errObj = err.message;

    }

    return errObj;

};

baseRequest.interceptors.request.use(

    ( config ) => {

        return config;

    },

    ( error ) => {

        const e = errorHandling( error );
        return Promise.reject( e );

    }

);

baseRequest.interceptors.response.use(

    ( response ) => {

        return response;

    },

    ( error ) => {

        const e = errorHandling( error );
        return Promise.reject( e );

    }

);

export const apiGetPeopleData = () => baseRequest.get( "/microwaveData/get_latest" );
export const apiGetSpinStatus = () => baseRequest.get( "/microwaveData/spin" );
export const apiPostSpinStatus = ( data ) => baseRequest.post( "/microwaveData/spin_button", data );
export const apiPostPicSave = ( data ) => baseRequest.post( "/base64/create", data );
export const apiGetPicSaved = () => baseRequest.get( "/base64/get_latest" );
